import React from 'react'
import InstructorNavbar from "../components/instructor/InstructorNavbar"
import GetMarks from '../components/instructor/GetMarks'

const GetMarksPage = () => {
  return (
    <div>
       <InstructorNavbar/>
       <GetMarks/>
    </div>
  )
}

export default GetMarksPage